import axios from 'axios';
import { toast } from 'sonner';

import i18n from '@/i18n';

const API_URL = import.meta.env.VITE_BACKEND_URL.replace('//$/', '');

const API = axios.create({
    baseURL: API_URL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
    withXSRFToken: true,
});

API.interceptors.response.use(
    (response) => response,
    (error) => {
        const data = error?.response?.data;

        if (
            error?.response?.status === 403 &&
            typeof data?.type === 'string' &&
            data.type.endsWith('subscription-inactive')
        ) {
            toast.error(i18n.t('subscription.banner.blockedToast'), {
                id: 'subscription-inactive',
            });
        }

        return Promise.reject(error);
    }
);

export default API;
export {API_URL};
